<template>
  <object v-html="symbols"></object>
</template>

<script>
export default {
  name: 'svg-symbols',
  props: { name: String },
  beforeMount() {
    this.$http.get(`/static/svg/${this.name}-symbols.svg`)
      .then(response => response.blob())
      .then(blob => {
        let reader = new FileReader()
        reader.onload = () => { this.symbols = reader.result }
        reader.readAsText(blob)
      })
  },

  data() {
    return {
      symbols: null
    }
  }
}
</script>

<style scoped>
  object { display: none }
</style>



// WEBPACK FOOTER //
// SvgSymbols.vue?2b71d3ee